<template>
  <a-form-model ref="resetPassForm" :model="form" :rules="rules">
    <a-form-model-item prop="pass">
      <a-input @blur="tip = false" @click="passInput" v-model="form.pass" type="password" :maxLength="18" placeholder="请输入密码">
        <a-tooltip slot="suffix" v-model="tip" trigger="click">
          <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
          <template slot="title">
            <div>
              <p :class="{ red: !passValid.len }">长度为6-18个字符</p>
              <p :class="{ red: !passValid.complex }">字母/数字以及标点符号至少包含2种</p>
            </div>
          </template>
        </a-tooltip>
      </a-input>
    </a-form-model-item>
    <a-form-model-item prop="checkPass">
      <a-input @blur="checkTip = false" @click="checkPassInput" v-model="form.checkPass" type="password" placeholder="请再次输入密码" :maxLength="18">
        <a-tooltip slot="suffix" v-model="checkTip" trigger="click">
          <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
          <template slot="title">
            <div>
              <p :class="{ red: !checkPassValid.len }">长度为6-18个字符</p>
              <p :class="{ red: !checkPassValid.complex }">字母/数字以及标点符号至少包含2种</p>
              <p :class="{ red: !checkPassValid.same }">两次输入密码一致</p>
            </div>
          </template>
        </a-tooltip>
      </a-input>
    </a-form-model-item>
    <a-form-model-item>
      <a-button type="primary" @click="submit('resetPassForm')" :loading="loading">保存</a-button>
    </a-form-model-item>
  </a-form-model>
  <!-- <a-form :form="resetForm">
    <a-form-item>
      <a-input
        type="password"
        :maxLength="18"
        placeholder="请输入密码"
        v-decorator="['pass', { rules: [{ required: true, message: '请输入密码' }, { pattern: passReg, message: '密码强度不符合' }], validateTrigger: ['blur', 'change'] }]"
      >
        <a-tooltip slot="suffix">
          <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
          <template slot="title">
            <div>
              <p>长度为6-18个字符</p>
              <p>字母/数字以及标点符号至少包含2种</p>
            </div>
          </template>
        </a-tooltip>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input
        type="password"
        placeholder="请再次输入密码"
        :maxLength="18"
        v-decorator="['checkPass', { rules: [{ validator: this.confirmPassword }, { pattern: passReg, message: '密码强度不符合' }], validateTrigger: ['blur', 'change'] }]"
      />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" @click="submit" :loading="loading">保存</a-button>
    </a-form-item>
  </a-form> -->
</template>
<script>
import { passReg, passComplexReg } from '@/utils/regs'
export default {
  name: '',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      passReg,
      form: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [
          { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
          { pattern: passReg, message: '密码强度不符合', trigger: ['blur'] }
        ],
        checkPass: [
          { validator: this.confirmPassword, trigger: ['blur', 'change'] },
          { pattern: passReg, message: '密码强度不符合', trigger: ['blur'] }
        ]
      },
      tip: false,
      checkTip: false,
      checkPassValid: {
        len: false,
        complex: false,
        same: false
      },
      passValid: {
        len: false,
        complex: false,
      },
      // resetForm: this.$form.createForm(this, { name: 'resetForm' })
    }
  },
  watch: {
    'form.pass'(val) {
      this.checkPassValid.same = (this.form.pass === this.form.checkPass)
      if (!val.trim()) {
        this.passValid.len = false
        this.passValid.complex = false
        this.passValid.same = false
        return
      }
      if (val.trim().length > 5 && val.trim().length < 19) {
        this.passValid.len = true
      } else {
        this.passValid.len = false
      }
      this.passValid.complex = passComplexReg.test(val.trim())
    },
    'form.checkPass'(val) {
      if (!val.trim()) {
        this.checkPassValid.len = false
        this.checkPassValid.complex = false
        this.checkPassValid.same = false
        return
      }
      if (val.trim().length > 5 && val.trim().length < 19) {
        this.checkPassValid.len = true
      } else {
        this.checkPassValid.len = false
      }
      this.checkPassValid.complex = passComplexReg.test(val.trim())
      this.checkPassValid.same = (this.form.pass === this.form.checkPass)
    }
  },
  components: {},
  methods: {
    passInput() {
      !this.tip && (this.tip = true)
    },
    checkPassInput() {
      !this.checkTip && (this.checkTip = true)
    },
    confirmPassword(rule, value, callback) {
      const password = this.form.pass
      if (value === undefined || !value) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    submit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          this.$emit('confirm', this.form)
        }
      })
      // this.resetForm.validateFields((error, values) => {
      //   if (error) {
      //     console.log('error', error)
      //     return
      //   }
      //   this.$emit('confirm', values)
      // })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';
.red {
  color: #F55;
}
</style>
